"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionLowRateChargingTelemetrySerialization = void 0;
class ChargingTransactionLowRateChargingTelemetrySerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.detailTime = entity.detailTime
            ? entity.detailTime.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.detailTime = entity.detailTime
            ? new Date(entity.detailTime / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargingTransactionLowRateChargingTelemetrySerialization = ChargingTransactionLowRateChargingTelemetrySerialization;
